import { useState, useCallback } from "react";

export const usePassword = () => {
    const [password, setPassword] = useState('');
    
    const generate = useCallback((length, settings) => {
        const charset = {
            letters: "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ",
            numbers: "0123456789",
            symbols: "!@#$%^&*()_+~`|}{[]:;?><,./-="
        };
        
        let availableChars = charset.letters;
        if (settings.includeNumbers) availableChars += charset.numbers;
        if (settings.includeSymbols) availableChars += charset.symbols;
        
        const array = new Uint32Array(length);
        window.crypto.getRandomValues(array);
        
        let result = "";
        for (let i = 0; i < length; i++) {
            result += availableChars.charAt(array[i] % availableChars.length);
        }
        setPassword(result);
    }, []);

    const calculateStrength = useCallback((length, settings) => {
        let poolSize = 0;
        if (settings.includeNumbers) poolSize += 10;
        if (settings.includeSymbols) poolSize += 32;
        poolSize += 52; // letters
        
        const entropy = Math.floor(length * Math.log2(poolSize));
        if (entropy < 64) return { label: 'Weak', color: '#ff4d4d', percent: 25 };
        if (entropy < 80) return { label: 'Fair', color: '#ffa500', percent: 50 };
        if (entropy < 100) return { label: 'Strong', color: '#00ff88', percent: 75 };
        return { label: 'Unbreakable', color: '#00e1ff', percent: 100 };
    }, []);

    return { password, generate, calculateStrength };
};
